module.exports = __webpack_public_path__ + "img/dengji6.9f88a1d3.png";